import { render, staticRenderFns } from "./OverlayLoading.vue?vue&type=template&id=489b9ba6&scoped=true"
import script from "./OverlayLoading.vue?vue&type=script&lang=ts"
export * from "./OverlayLoading.vue?vue&type=script&lang=ts"
import style0 from "./OverlayLoading.vue?vue&type=style&index=0&id=489b9ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b9ba6",
  null
  
)

export default component.exports